import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetOrderQuestionSubOrderDetailPage } from '../../../../url-handling'
import { useContactPageLastOrderContext } from '../ContactPageLastOrderContext'

import { type ContactPageSelfServiceShortcutProps } from './ContactPageSelfServiceShortcutProps'

export const ContactPageSelfServiceShortcutViewAllCta: FC<
  ContactPageSelfServiceShortcutProps
> = () => {
  const config = useGlobalConfigContext()
  const { activeSubOrder, firstSubOrder, lastOrder } =
    useContactPageLastOrderContext()
  const subOrder = activeSubOrder ?? firstSubOrder

  if (!subOrder?.subOrderId || !lastOrder?.orderMasterData?.orderNumber) {
    return null
  }

  return (
    <Button<'a'>
      endIcon={<IconArrowRight />}
      href={urlResolverGetOrderQuestionSubOrderDetailPage(
        config,
        lastOrder.orderMasterData.orderNumber,
        subOrder.subOrderId,
      )}
      size="small"
      variant="text"
    >
      <FormattedMessage id="account.redpoints.activity.showMore" />
    </Button>
  )
}
